import { useEffect, useState } from "react";
import { LoaderScreen } from "../../components/LoaderScreen";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import SortIcon from '@mui/icons-material/Sort';

export const FiltroListadoPrecio = ({
    data,
    datafiltro,
    setDatafiltro,
    filtrar,
    setFiltrar,
    keyFiltrado,
    selectedFilters,
    setSelectedFilters
}) => {
    const [stateError, setError] = useState("");
    const [show, setShow] = useState(false);


    const [state, setState] = useState([])
    

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        const filteredData = data.filter(item => {
            // console.log("Comparando sucursal:", item.tiene_promocion, selectedFilters.promocion);

            // Convertir fecha_recepcion de dd/mm/yyyy a yyyy-mm-dd
            const fechaRecepcionArray = item.fecha_recepcion.split('/');
            const fechaRecepcion = new Date(`${fechaRecepcionArray[2]}-${fechaRecepcionArray[1]}-${fechaRecepcionArray[0]}`);

            // Cálculo de la diferencia de meses entre la fecha de recepción y la fecha actual
            const fechaActual = new Date();
            const mesesDeDiferencia = (fechaActual.getFullYear() - fechaRecepcion.getFullYear()) * 12 + (fechaActual.getMonth() - fechaRecepcion.getMonth());
            // console.log("Comparando meses:", mesesDeDiferencia);
            return (
                (selectedFilters.sucursal.length === 0 || selectedFilters.sucursal.map(Number).includes(item.sucursal)) &&
                (selectedFilters.promocion.length === 0 || selectedFilters.promocion.includes(item.tiene_promocion)) &&
                (selectedFilters.estatus.length === 0 || selectedFilters.estatus.includes(item.estatus)) &&
                (selectedFilters.ejercicio.length === 0 || selectedFilters.ejercicio.includes(item.ejercicio)) &&
                (selectedFilters.modelo.length === 0 || selectedFilters.modelo.includes(item.modelo)) &&
                (selectedFilters.hp.length === 0 || selectedFilters.hp.includes(item.hp)) &&
                (selectedFilters.tipo.length === 0 || selectedFilters.tipo.some(tipo =>
                    tipo === 'Tractores' ? item.modelo_descripcion.toLowerCase().includes('tractor') :
                        tipo === 'Trilladoras' ? (item.modelo_descripcion.toLowerCase().includes('trilladora') || item.modelo_descripcion.toLowerCase().includes('cabezal')) : false
                )) &&
                (selectedFilters.antiguedad.length === 0 || selectedFilters.antiguedad.some(ant => {
                    if (ant === '0-3') return mesesDeDiferencia <= 3;
                    if (ant === '3-6') return mesesDeDiferencia > 3 && mesesDeDiferencia <= 6;
                    if (ant === '6-12') return mesesDeDiferencia > 6 && mesesDeDiferencia <= 12;
                    if (ant === '12+') return mesesDeDiferencia > 12;
                    return false;
                }))

            );
        });

        setState(filteredData);
    }, [selectedFilters,data]);

    useEffect(() => {
        const filteredData = data.filter(item => {
            // console.log("Comparando sucursal:", item.tiene_promocion, selectedFilters.promocion);

            // Convertir fecha_recepcion de dd/mm/yyyy a yyyy-mm-dd
            const fechaRecepcionArray = item.fecha_recepcion.split('/');
            const fechaRecepcion = new Date(`${fechaRecepcionArray[2]}-${fechaRecepcionArray[1]}-${fechaRecepcionArray[0]}`);

            // Cálculo de la diferencia de meses entre la fecha de recepción y la fecha actual
            const fechaActual = new Date();
            const mesesDeDiferencia = (fechaActual.getFullYear() - fechaRecepcion.getFullYear()) * 12 + (fechaActual.getMonth() - fechaRecepcion.getMonth());
            // console.log("Comparando meses:", mesesDeDiferencia);
            return (
                (selectedFilters.sucursal.length === 0 || selectedFilters.sucursal.map(Number).includes(item.sucursal)) &&
                (selectedFilters.promocion.length === 0 || selectedFilters.promocion.includes(item.tiene_promocion)) &&
                (selectedFilters.estatus.length === 0 || selectedFilters.estatus.includes(item.estatus)) &&
                (selectedFilters.ejercicio.length === 0 || selectedFilters.ejercicio.includes(item.ejercicio)) &&
                (selectedFilters.modelo.length === 0 || selectedFilters.modelo.includes(item.modelo)) &&
                (selectedFilters.hp.length === 0 || selectedFilters.hp.includes(item.hp)) &&
                (selectedFilters.tipo.length === 0 || selectedFilters.tipo.some(tipo =>
                    tipo === 'Tractores' ? item.modelo_descripcion.toLowerCase().includes('tractor') :
                        tipo === 'Trilladoras' ? (item.modelo_descripcion.toLowerCase().includes('trilladora') || item.modelo_descripcion.toLowerCase().includes('cabezal')) : false
                )) &&
                (selectedFilters.antiguedad.length === 0 || selectedFilters.antiguedad.some(ant => {
                    if (ant === '0-3') return mesesDeDiferencia <= 3;
                    if (ant === '3-6') return mesesDeDiferencia > 3 && mesesDeDiferencia <= 6;
                    if (ant === '6-12') return mesesDeDiferencia > 6 && mesesDeDiferencia <= 12;
                    if (ant === '12+') return mesesDeDiferencia > 12;
                    return false;
                }))

            );
        });


        setDatafiltro(filteredData);  // Se actualiza solo cuando hay estatus seleccionado.
    }, [data, keyFiltrado, filtrar]);

    useEffect(() => {
        if (filtrar) {
            if (keyFiltrado === "T") {
                setSelectedFilters({ ...selectedFilters, estatus: [] })
                setFiltrar(false);
                // setDatafiltro(data)
            }
            else {
                handleFilterStateChange('estatus', keyFiltrado);
                setFiltrar(false);
            }
        }
    }, [filtrar]);

    // Función para manejar el filtro de estus (en caso de usar la logica anterior, solo se manda a llamar handleFilterChange)
    const handleFilterStateChange = (filterName, value) => {
        console.log("me ejecuto: ", value)
        setSelectedFilters(prevState => {
            const currentValues = prevState[filterName];
            if (currentValues.includes(value)) {
                return {
                    ...prevState,
                    [filterName]: currentValues.filter(item => item !== value),
                };
            }
            else {
                return {
                    ...prevState,
                    [filterName]: [value],
                };
            }
        });
    };

    // Función para manejar cambios en los checkboxes
    const handleFilterChange = (filterName, value) => {
        setSelectedFilters(prevState => {
            const currentValues = prevState[filterName];
            if (currentValues.includes(value)) {
                return {
                    ...prevState,
                    [filterName]: currentValues.filter(item => item !== value),
                };
            } else {
                return {
                    ...prevState,
                    [filterName]: [...currentValues, value],
                };
            }
        });
    };

    const onClick = () => {
        setShow(true);
        const element = document.getElementById("box-structure-bussiness-filtros-listado-precios-usados");
        if (element != undefined && element != null) {
            element.style.display = "flex";
        }
    };

    const onClose = () => {
        setShow(false);
        const element = document.getElementById("box-structure-bussiness-filtros-listado-precios-usados");
        if (element != undefined && element != null) {
            element.style.display = "none";
        }
        closeConsulta();
    };
    const closeConsulta = () => { };


    const onGuardar = () => {
        setDatafiltro(state)
        onClose()
    }

    const capitalizeWords = (str) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
    };

    return (
        <>
            <LoaderScreen loader={loader} />
            <div className="plantilla-screen-filtro-A">
                <div>
                    <div className="plantilla-screen-filtro-button-modal-A" onClick={onClick}>
                        {/* <button className="boton-box-structure" > */}
                        <FilterAltIcon />
                        Filtrar

                        {/* <header>
                            <div className="titulo">{titulo}</div>
                            <div className="sub-titulo">{subtitulo}</div>
                        </header> */}
                    </div>
                </div>
            </div>
            {show === true && (
                <div
                    id="box-structure-bussiness-filtros-listado-precios-usados"
                    key="box-structure-bussiness-filtros"
                >
                    <div className="filtro-soy-el-titulo-listado-precio">
                        <div className="filtro-soy-el-titulo-header">
                            {"Filtro Listado"}
                            <span className="filtro-soy-span-close" onClick={onClose}>
                                X
                            </span>
                        </div>
                        <div className="filtro-soy-el-titulo-line-listado-precio">
                            <div className="filtro-soy-el-titulo-line-bl"></div>
                            <div className="filtro-soy-el-titulo-line-circle"></div>
                            <div className="filtro-soy-el-titulo-line-br"></div>
                        </div>
                    </div>


                    <div className="box-action-container-filtros">
                        <div className="filtro-periodo">
                            <div className="title title-adr">Sucursal</div>
                            {[
                                ...new Set(data.map(item => item.sucursal)) // Filtramos valores únicos de `hp`
                            ]
                                .sort((a, b) => a - b) // Ordenamos de menor a mayor
                                .map((sucursalId, index) => {
                                    const sucursalName = data.find(item => item.sucursal === sucursalId)?.nombre_sucursal;
                                    return (
                                        <div key={index} className="chk-groups">
                                            <input
                                                type="checkbox"
                                                name="chk-periodo"
                                                onChange={() => handleFilterChange('sucursal', sucursalId)}
                                                value={sucursalId}
                                                checked={selectedFilters.sucursal.includes(sucursalId)}  
                                            />
                                            <label>{sucursalName}</label>
                                        </div>
                                    )
                                })}
                        </div>

                        {/* Sección de Tipo */}
                        <div className="filtro-periodo">
                            <div className="title title-adr">Tipo</div>
                            <div className="chk-groups">
                                <input
                                    type="checkbox"
                                    name="chk-tractores"
                                    onChange={() => handleFilterChange('tipo', 'Tractores')}
                                    checked={selectedFilters.tipo.includes('Tractores')}
                                />
                                <label>Tractores</label>
                            </div>
                            <div className="chk-groups">
                                <input
                                    type="checkbox"
                                    name="chk-trilladoras"
                                    onChange={() => handleFilterChange('tipo', 'Trilladoras')}
                                    checked={selectedFilters.tipo.includes('Trilladoras')}
                                />
                                <label>Trilladoras</label>
                            </div>
                        </div>


                        <div className="filtro-periodo">
                            <div className="title title-adr">Antigüedad</div>
                            <div className="chk-groups">
                                <input
                                    type="checkbox"
                                    name="chk-0-3"
                                    onChange={() => handleFilterChange('antiguedad', '0-3')}
                                    checked={selectedFilters.antiguedad.includes('0-3')}
                                />
                                <label>0-3 meses</label>
                            </div>
                            <div className="chk-groups">
                                <input
                                    type="checkbox"
                                    name="chk-3-6"
                                    onChange={() => handleFilterChange('antiguedad', '3-6')}
                                    checked={selectedFilters.antiguedad.includes('3-6')}
                                />
                                <label>3-6 meses</label>
                            </div>
                            <div className="chk-groups">
                                <input
                                    type="checkbox"
                                    name="chk-6-12"
                                    onChange={() => handleFilterChange('antiguedad', '6-12')}
                                    checked={selectedFilters.antiguedad.includes('6-12')}
                                />
                                <label>6-12 meses</label>
                            </div>
                            <div className="chk-groups">
                                <input
                                    type="checkbox"
                                    name="chk-12+"
                                    onChange={() => handleFilterChange('antiguedad', '12+')}
                                    checked={selectedFilters.antiguedad.includes('12+')}
                                />
                                <label>12+ meses</label>
                            </div>
                        </div>

                        <div className="filtro-periodo">
                            <div className="title title-adr">HP</div>
                            {[
                                ...new Set(data.map(item => item.hp)) // Filtramos valores únicos de `hp`
                            ]
                                .sort((a, b) => a - b) // Ordenamos de menor a mayor
                                .map((hp, index) => (
                                    <div key={index} className="chk-groups">
                                        <input
                                            type="checkbox"
                                            name="chk-periodo"
                                            onChange={() => handleFilterChange('hp', hp)}
                                            value={hp}
                                            checked={selectedFilters.hp.includes(hp)}
                                        />
                                        <label>{hp}</label>
                                    </div>
                                ))}
                        </div>

                    </div>
                    <div className="filtro-listado-precio-button-cargar-container">
                        <button className="filtro-listado-precio-button-cargar" onClick={() => onGuardar()}> <SortIcon />Cargar</button>
                    </div>
                </div>
            )}

        </>
    );
};